import styles from './Main.module.css'; // Import styles

const Main = () => {
    return (
        <div>
    <p>The PlantaeViz platform is a web-based platform that offers several tools to visualize gene expression data in different transcriptomic datasets (microarray or RNA-Seq) related to the Plantae kingdom. You can also explore gene-co-expression networks, gene function associations, DAP-Seq data, and correlations between gene expression and metabolites. The platform is part of TOMSBiolab at the Institute of Integrative Systems Biology (I2SYSBIO, UV - CSIC). The platform also includes a search engine for looking correspondences between different genome annotations and Reference Catalogues for each of the species.</p>
    <br></br>
    <p>If you detect any bug or just want to give us some feedback, please contact Antonio Santiago: <strong>antsanpaj (at) gmail.com</strong> or David Navarro: <strong>david.navarro.paya (at) gmail.com</strong></p>
    <br></br>

            <h1 style={{ fontSize: '32px' }}><strong>Reference to the Gene Catalogue and Gene Cards:</strong></h1>
            <br></br>
            <p>Navarro-Payá, D., Santiago, A., Orduña, L., Zhang, C., Amato, A., D’Inca, E., Fattorini, C., Pezzotti, M., Tornielli, G. B., Zenoni, S., Rustenholz, C., & Matus, J. T. (2022). <strong>The Grape Gene Reference Catalogue as a Standard Resource for Gene Selection and Genetic Improvement</strong>. <em>Frontiers in Plant Science</em>, 12, 803977. <a href="https://doi.org/10.3389/fpls.2021.803977" target="_blank" style={{color: 'blue'}}>https://doi.org/10.3389/fpls.2021.803977</a>.</p>
            <br></br>
            <br></br>

            <h1 style={{ fontSize: '32px' }}><strong>Reference to AggGCNs:</strong></h1>
            <br></br>
            <p>Luis Orduña, Antonio Santiago, David Navarro-Payá, Chen Zhang, Darren C J Wong, José Tomás Matus (2023). <strong>Aggregated gene co-expression networks predict transcription factor regulatory landscapes in grapevine</strong>, <em>Journal of Experimental Botany</em>, erad344, <a href="https://doi.org/10.1093/jxb/erad344" target="_blank" style={{color: 'blue'}}>https://doi.org/10.1093/jxb/erad344</a>.</p>
            <br></br>
            <br></br>
            
            <h1 style={{ fontSize: '32px' }}><strong>Reference to TransMetaDB:</strong></h1>
            <br></br>
            <p>Savoi, S., Santiago, A., Orduña, L., & Matus, J. T. (2022). <strong>Transcriptomic and metabolomic integration as a resource in grapevine to study fruit metabolite quality traits</strong>. <em>Frontiers in Plant Science</em>, 16. <a href="https://www.frontiersin.org/articles/10.3389/fpls.2022.937927" target="_blank" style={{color: 'blue'}}>https://doi.org/10.3389/fpls.2022.937927</a>.</p>
            <br></br>
            
            <h2 style={{ fontSize: '22px' }}><strong>Acknowledgements</strong></h2>
            <br></br>
<div className={styles.acknowledgement}> 

          <img src="/PlantViz_images/Logo_del_Ministerio_de_Ciencia,_Innovación_y_Universidades.svg.png" alt="Ministerio de Ciencia, Innovación y Universidades" width="400" height="auto" />
          <img src="/PlantViz_images/Logo_Generalitat_Valenciana-logo-F57B73876C-seeklogo.com.png" alt="Generalitat Valenciana" width="200" height="auto" />
          <img src="/PlantViz_images/Logo_IEC.png" alt="IEC" width="100" height="auto" />
          <img src="/PlantViz_images/Logo_biogenoma.png" alt="Biogenoma" width="300" height="auto" />
        
      </div>
            
        </div>
    );
}

export default Main;
